import { memo } from 'react'
import LoadingCircle from '../loaders/LoadingCircle'

const WeedgetLoading = () => {
  return (
    <Flex $justifyContent='center' $alignSelf='center' $p='md' $alignItems='center' $flex={1}>
      <LoadingCircle size='lg' color={'grayscale.black'} />
    </Flex>
  )
}

export default memo(WeedgetLoading)
